import SimpleCardBox from "./SimpleCardBox";
import CollapsibleItem from "./CollapsibleItem";
import SimpleEvenFlex from "./SimpleEvenFlex";
import EditableCardEntryInput from "../editable_entries/EditableCardEntryInput";
import {formatISOUTCYMD, formatISOYMD} from "../../util/DateUtils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons/faEye";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import SimpleModal from "../modals/SimpleModal";
import {useState} from "react";
import EditableSelect from "../editable_entries/EditableSelect";
import {SC_SubFileType} from "../../util/api/files/SC_SubFileType";
import EditableCardEntryFile, {UPLOAD_FILE_TYPE_GENERIC} from "../editable_entries/EditableCardEntryFile";

/**
 * @param {SC_Subcontractor} sub
 * @param {SC_SubcontractorFile[]} files
 * @constructor
 */
const SubcontractorFilesCard = ({sub, files, callReload}) => {
    let activeFiles = files.filter(it => it.active).sort((a, b) => a.endDate - b.endDate);
    let inActiveFiles = files.filter(it => !it.active).sort((a, b) => a.endDate - b.endDate);

    const [uploadFile, setUploadFile] = useState(false);
    const [pendingType, setPendingType] = useState(SC_SubFileType.NULL);
    const [pendingFile, setPendingFile] = useState(null);
    const [fileValid, setFileValid] = useState(false);
    const [fileHref, setFileHref] = useState(undefined);

    const [fileExpiration, setFileExpiration] = useState(null);
    const [fileStart, setFileStart] = useState(null);

    let baseValue;

    if (fileStart) {
        baseValue = formatISOUTCYMD(fileStart);
    } else if (fileExpiration) {
        baseValue = new Date(fileExpiration.getTime());
        baseValue.setUTCFullYear(baseValue.getUTCFullYear() - 1);
        baseValue = formatISOUTCYMD(baseValue);
    }

    function onFileChange(e) {
        const file = e[0];

        setPendingFile(file);

        if (file) {
            setFileHref(URL.createObjectURL(file));
        } else {
            setFileHref(undefined);
        }

        setFileValid(!!file);
    }

    function uploadSubFile() {
        let formData = new FormData();

        formData.append("sub_id", sub.internalID);
        formData.append("type", pendingType);

        formData.append("start", baseValue);
        formData.append("end", formatISOUTCYMD(fileExpiration));

        formData.append("file", pendingFile);

        doRequest(uploadFile, "upload_sub_file").then(v => {
            if (v.code === 200) {
                callReload(v.reason);
            }
        })
    }

    return <div style={{width:'100%'}}>
        <SimpleModal requestedSizing={pendingFile ? "large-modal" : ""} title={"Upload Sub File"} isOpen={uploadFile} onClose={() => setUploadFile(false)}>
            <SimpleEvenFlex enforceEven={false} fullWidth={true}>
                <div style={{marginRight: pendingFile ? "40px" : ""}}>
                    <EditableSelect
                        displayLabel={"File Type"}
                        items={SC_SubFileType.originator}
                        idKey={"key"}
                        nameKey={"display"}
                        onSelect={setPendingType}
                        defaultValue={pendingType}
                    />
                    {pendingType !== SC_SubFileType.NULL ? <EditableCardEntryFile
                        isEditing={true}
                        displayLabel={"File Upload"}
                        accept={UPLOAD_FILE_TYPE_GENERIC}
                        onEdit={onFileChange}
                    /> : null}
                    {pendingFile && pendingType !== SC_SubFileType.NULL ? <div>
                        <EditableCardEntryInput
                            type={"date"}
                            isEditing={true}
                            displayLabel={"File Expiration"}
                            onEdit={(v) => setFileExpiration(new Date(v))}
                        />
                        <EditableCardEntryInput
                            type={"date"}
                            isEditing={true}
                            displayLabel={"File Start"}
                            baseValue={baseValue ?? null}
                            onEdit={(v) => setFileStart(new Date(v))}
                        />
                    </div> : null}
                    {pendingFile && pendingType !== SC_SubFileType.NULL ? <button>Submit</button> : null}
                </div>
                {fileValid ? <div style={{flexGrow: 1}}>
                    <iframe style={{display: "block", margin: "auto", height: "100%", width: "100%"}} src={fileHref}/>
                </div> : null}
            </SimpleEvenFlex>
        </SimpleModal>
        <CollapsibleItem title={"Active Files"} startCollapsed={false} titleItems={<FontAwesomeIcon icon={faPlus} onClick={(e) => {e.stopPropagation(); setUploadFile(true)}}/>}>
            <div style={{padding: "5px"}}><SimpleEvenFlex growUp={false} >
                {activeFiles.map(it => <SubcontractorFileCard file={it} />)}
            </SimpleEvenFlex></div>
        </CollapsibleItem>
        {inActiveFiles.length ? <CollapsibleItem title={"Inactive Files"} startCollapsed={true}>
            <SimpleEvenFlex growUp={false}>
                {inActiveFiles.map(it => <SubcontractorFileCard file={it} />)}
            </SimpleEvenFlex>
        </CollapsibleItem> : null}
    </div>;
}

export default SubcontractorFilesCard;

/**
 * @param {SC_SubcontractorFile} file
 * @constructor
 */
const SubcontractorFileCard = ({ file }) => {
    return <SimpleCardBox animateHover={true} defaultPadding={true} defaultMargin={false} extraClass={"small-margin"}>
        <div className={"float-around-header-box"}>
            <div className={"float-around-header"}><span>{file.type.toString()}</span></div>
            <a target={"_blank"} href={file.internal_href} title={"View this file"}><FontAwesomeIcon icon={faEye}/></a>
        </div>
        <SimpleEvenFlex>
            <EditableCardEntryInput
                type={"date"}
                isEditing={false}
                displayLabel={"End Date"}
                baseValue={formatISOYMD(file.endDate)}
            />
            <EditableCardEntryInput
                type={"date"}
                isEditing={false}
                displayLabel={"Start Date"}
                baseValue={formatISOYMD(file.startDate)}
            />
        </SimpleEvenFlex>
    </SimpleCardBox>
}